import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../../context/auth';
// import axios from 'axios';
// import moment from 'moment';
// import { Link } from 'react-router-dom';

import { Mensaje } from '../../mensajes2';

import { Dimmer } from "../../spinner";

// import CajaIngresos from './cajaingresos';
import { ReversarTransaccion } from './modalReversarTransaccion';
/* import Ingresos from '../../../../IngresosCaja'; */
import ValidarUsuario from '../../comun/modalValidarUsuario';
import CerrarAbrirMes from './modalAbrirCerrarMes';
import TablaMovimientosBancos from './notasCredito';
import ImpModalCaja from './modalImpCaja';
import CajaIngresos2 from './cajaImgresos2';
import CajaIngresos3 from './cajaIngreso3';
import { FacturacionEtax } from './modalFacrutacionEtax';
import Menu from '../../comun/Menu/Menu';
import Item from '../../comun/Menu/Item';
import DasboardCaja from './grafiacasCaja';
import AnalisisModuloCaja from './AnalisisModuloCaja'
import Axios from 'axios';

function MenuPrincipalCaja() {

  const { user } = useContext(AuthContext);
  const [mostrar, setMostrar] = useState(false);
  const [mostrarEtax, setMostrarEtax] = useState(false);

  const [mostrarImp, setMostrarImp] = useState(false);

  const [operacion, setOperacion] = useState()
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [mostrarCerrarAbrir, setMostrarCerrarAbrir] = useState(false);
  const [tipoCaja, setTipoCaja] = useState();
  const [nomOrg, setNomOrg] = useState('');
  const [usuario, setUsuario] = useState('');
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
  const [liquidador, setLiquidador] = useState(localStorage.getItem('liquidador'));
  const [liquida, setLiquida] = useState(localStorage.getItem('liquida'));
  const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
  const [anio, setAnio] = useState();
  const [tabla, setTabla] = useState(0);
  const [show, setShow] = useState(false)


  var op = require('../../../../src/modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const cargarotropago = (tipo) => (e) => {
    e.preventDefault();
    if (numcaja === '' || numcaja === null) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: 'El Usuario no Tiene Número de Caja Asignado', icono: 'error' });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrar2(true);

  }

  const seleccionarImpresora = (printer) => {
    let campos = '*';
    let nomtab = 'impresoras';
    let condi = `descripcion = '${printer}' and status = 1`;
    let orden = '1';
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    console.log(endpoint)
    Axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        let impresora = [];
        for (let i = 0; i < response.data.length; i++) {
          impresora.push({
            message: "imprimir",
            server: response.data[i].descripcion.toLowerCase(),
            impresora: response.data[i].modelo,
            idfactura: 0,
            fecha: "",
            tipo: '',
            copias: 1,
            papel: response.data[i].papel,
            tipopago: "",
            socket: true
          });
        }
        console.log(impresora);
        localStorage.setItem("impresora", JSON.stringify(impresora));
      }
      setActivate(false);

    }).catch(function (error) {
      console.log(error)
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    }).finally(function () {
      setActivate(false);
    });
  };

  useEffect(() => {

    let obj = JSON.parse(localStorage.getItem('post'));
    setFechaSistema(obj.fechasistema);
    console.log(obj.nameprint);
    seleccionarImpresora(obj.nameprint);
    if (obj != null) {

      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);

      setLiquidador(obj.liquidador);
      setLiquida(obj.liquida);
      setFechaSistema(obj.fechasistema);
      setEspiritu(obj.espiritu);
      var nanio = []
      var aini = parseInt(obj.anioactu) - 7;
      var afin = parseInt(obj.anioactu);
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: aini + i });

      }
      setAnio(nanio);


    } else {

      setUsuario('');
      setNomOrg('');

    }

  }, []);

  useEffect(() => {

    if (tabla === 4) {
      setMostrar(true);
    } else if (tabla === 9) {
      setMostrarEtax(true)
    } else if (tabla === 7) {
      setMostrarUsuario(true)
      setTipoCaja(1)
    } else if (tabla === 8) {
      setMostrarUsuario(true)
      setTipoCaja(0)
    } else if (tabla === 10) {
      setOperacion(1)
      setMostrarImp(true)
    } else if (tabla === 11) {
      setOperacion(2)
      setMostrarImp(true)
    } else if (tabla === 12) {
      setOperacion(3)
      setMostrarImp(true)
    } else if (tabla === 13) {
      setOperacion(4)
      setMostrarImp(true)
    } else if (tabla === 14) {
      setOperacion(5)
      setMostrarImp(true)
    } else if (tabla === 15) {
      setOperacion(6)
      setMostrarImp(true)
    }

  }, [tabla]);

  // const itemClick = (op) => (e) => {
  //   menuclick()
  //   setTabla(op)

  // }

  const modalReversarTransaccion = () => {
    setMostrar(false);
    setTabla(0)
  }



  const cerrarAbrirCaja = () => {
    setMostrarUsuario(false)
    setMostrarCerrarAbrir(true)
  }

  const resumenGrafica = {
    title: 'Analisis Grafico',
    icon: 'fa fa-chart-pie me-2',

    drop: [
      {
        title: 'RESUMEN Y ANALISIS GRAFICO',
        icon: 'fas fa-screwdriver me-2',
        itemClickValue: 116
      },

    ]
  }

  const actualizacionItem = {
    title: 'Facturar',
    icon: 'fas fa-credit-card me-2',
    drop: [
      {
        title: 'Facturación Integral',
        itemClickValue: 1,
        icon: 'fas fa-border-all me-2',
      },
      {
        title: 'Orden de Atención al Contribuyente',
        itemClickValue: 3,
        icon: 'fas fa-border-all me-2',
      },
      {
        title: 'Supervisor ',
        itemClickValue: null,
        icon: 'fas fa-user-tie me-2',
        subDrop: [
          {
            title: 'Reversar Transacción',
            itemClickValue: 4,
            icon: 'fas fa-history me-2',
          },
          {
            title: 'Ajustes Bancarios',
            itemClickValue: 5,
            icon: 'fas fa-address-card me-2',
          },
          {
            title: 'Resumen Cuentas Tesorería',
            itemClickValue: 6,
            icon: 'fas fa-address-card me-2',
          },
          {
            title: 'Cerrar Cajas',
            itemClickValue: 7,
            icon: 'fas fa-address-card me-2',
          },
          {
            title: 'Abrir Cajas',
            itemClickValue: 8,
            icon: 'fas fa-address-card me-2',
          },
          parseInt(espiritu) === 11 ? {
            title: 'Facturación ETAX',
            itemClickValue: 9,
            icon: 'fas fa-address-card me-2',
          } : ''
        ]
      },
    ]
  }
  const imprimirItem = {
    title: 'Imprimir',
    icon: 'fas fa-print me-2',
    drop: [
      {
        title: 'Resumen de Caja',
        itemClickValue: 10,
        icon: 'fas fa-print me-2',
      },
      {
        title: 'Resumen de caja por banco',
        itemClickValue: 11,
        icon: 'fas fa-print me-2',
      },
      {
        title: 'Transacciones diarias',
        itemClickValue: 12,
        icon: 'fas fa-print me-2',
      },
      {
        title: 'Transacciones diarias detalladas',
        itemClickValue: 13,
        icon: 'fas fa-print me-2',
      },
      {
        title: 'Transacciones reversadas',
        itemClickValue: 14,
        icon: 'fas fa-print me-2',
      },
      {
        title: 'Reporte de Transacciones',
        itemClickValue: 15,
        icon: 'fas fa-print me-2',
      },
    ]
  }


  const configuracionItem = {
    title: 'Movimientos Bancarios',
    icon: 'fas fa-university me-2',
    drop: [
      {
        title: 'Movimientos Bancarios',
        itemClickValue: 2,
        icon: 'fas fa-list-alt me-2',
      },

    ]
  }

  const vista = {
    0: <DasboardCaja />,
    1: <CajaIngresos2 />,
    2: <TablaMovimientosBancos setTabla={setTabla} />,
    3: <CajaIngresos3 />,
    116: <AnalisisModuloCaja />

  }

  return user && <div>
    <Menu fechaSistema={fechaSistema} op={op}>
      <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
      <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
      <Item item={resumenGrafica} setTabla={setTabla} setShow={setShow} />
      <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
      <a href="/haciendaMunicipal" className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"><i className="fas fa-power-off me-2" />Salir</a>
    </Menu>
    {vista[tabla]}


    <Mensaje mensaje={mensaje}
      onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />

    <Dimmer active={activate} inverted>
    </Dimmer>

    <ReversarTransaccion
      show={mostrar}
      onHideCancela={modalReversarTransaccion}
    />

    <FacturacionEtax
      show={mostrarEtax}
      onHideCancela={() => { setMostrarEtax(false), setTabla(0) }}
    />
    <ImpModalCaja
      operacion={operacion}
      show={mostrarImp}
      onHideCancelar={() => { setMostrarImp(false), setTabla(0) }}

    />

    <ValidarUsuario

      show={mostrarUsuario}
      onHideCancela={() => { setMostrarUsuario(false) }}
      onHideConfirmar={cerrarAbrirCaja}
      llamado={1}
    />

    <CerrarAbrirMes

      show={mostrarCerrarAbrir}
      onHideCancela={() => { setMostrarCerrarAbrir(false) }}
      llamado={1}
      operacion={tipoCaja}

    />
  </div>
} export default MenuPrincipalCaja;